import { SetLoader } from '../../redux/actions/loader'
import { DELETE, GET, POST, PUT } from '../API'
import {
  GetCreationTemplate,
  vehicleEnum,
} from '../configuration-template/index'
import { CreateXlsx } from '../xlsx'
import { store } from '../../redux/store'
// import customer from '../../redux/reducers/customer'
const { dispatch } = store

export {
  GetUserAssets,
  GetCustomerAssetsList,
  GetAssetInfo,
  getAssetDevices,
  saveAsset,
  ProvisionDevice,
  GetPaginationAssetsList,
  CreateDeviceCreateTemplateXlsx,
  GetCustomerAssetTypes,
  GetStorageTemplate,
  saveDevice,
  GetCustomerDevices,
  GetUserCustomers,
  GetSitesUnderCustomer,
  GetCustomerDevicesUpOnType,
  AssignAssetToDevice,
  saveColdDevice,
  UnassignDevice,
  AddorUpdateAssetToFacility,
  ChangeAssetStatus,
  AssignTemplateToAssets,
  GetCustomerDevicesWithSearch,
  UpdateAssetLabel,
  DeleteHierarchy,
  GetSitesWithMoreThanDevice,
  GetSiteDevices,
  SetMasterDevice,
  ASSET_STATUS_ENUM,
}

const ASSET_STATUS_ENUM = {
  REGISTERED: 'REGISTERED',
  CONFIGURED: 'CONFIGURED',
  PROVISIONED: 'PROVISIONED',
  ACTIVE: 'ACTIVE',
  ALL: 'ALL',
}

const DeleteHierarchy = async (queryParams, levelId) => {
  const res = await POST(
    `/spectro/assets/hierarchy/delete/${levelId}`,
    queryParams,
  )
  return res
}

const UpdateAssetLabel = async (queryParams, levelId) => {
  const res = await POST(
    `/spectro/assets/hierarchy/edit/${levelId}`,
    queryParams,
  )
  return res
}

const AssignTemplateToAssets = async (queryParams, body) => {
  const res = await POST('/spectro/templates/assets', queryParams, body)
  return res
}

// /spectro/customers/{email}

const GetUserCustomers = async (userEmail, productName) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/customers/${userEmail}`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    console.log('customers', response.data)
    return response.data
  }
  return []
}
// spectro/devices?product=cold&type=sensor&customerId=d8b 93577e8f&sku=SCTHD-01
const GetCustomerDevicesUpOnType = async (productName, type, customer, sku) => {
  const queryParams = {
    product: productName,
    type,
    customerId: customer,
    sku,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/devices/`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    console.log('customers', response.data)
    return response.data
  }
  return []
}
// spectro/assets/customer/aa@spectro.net?product=cold&page=0&size=5
const GetPaginationAssetsList = async (
  userEmail,
  productName,
  currentPage,
  size,
  customer,
  assetName,
) => {
  const queryParams = {
    product: productName,
    page: currentPage,
    size,
    customerId: customer,
    assetName,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}
// localhost:9999/spectro/storages/{storage type}?product=cold
const GetStorageTemplate = async (storageName, productName) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/storages/${storageName}`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}
// get user assets
const GetUserAssets = async (userEmail, productName, status) => {
  const queryParams = {
    product: productName,
    status,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

// const CreateAsset = async (userEmail, productName, asset, groupList) => {
//   dispatch(SetLoader(true))
//   const queryParams = {
//     product: productName,
//   }

//   const filteredGroupList = groupList.filter(
//     (group) => group.id === asset.groupId,
//   )

//   const body = {
//     'asset name': asset.assetName,
//     description: asset.description,
//     group: {
//       id: filteredGroupList[0].id,
//       name: filteredGroupList[0].name,
//       type: filteredGroupList[0].type,
//     },
//     'geo location': asset.latLng,
//     country: asset.countryName,
//     city: asset.cityName,
//     address: asset.address,
//     facility: asset.facilityName,
//   }

//   const response = await POST(`/spectro/assets/${userEmail}`, queryParams, body)
//   dispatch(SetLoader(false))
//   return response
// }

// spectro/assets/customer/aa@spectro.net?type=Facility&product=cold&from=Cairo

const GetCustomerAssetsList = async (
  userEmail,
  type,
  productName,
  ID,
  from,
) => {
  dispatch(SetLoader(true))
  console.log(userEmail, type, productName, from)
  const queryParams = {
    type,
    product: productName,
    customerId: ID,
  }
  if (from) {
    queryParams.from = from
  }

  const response = await GET(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
    // if (type === 'country') {
    //   dispatch(setCustomerCountries(response.data))
    // }
    // if (type === 'region') {
    //   dispatch(setCustomerRegions(response.data))
    // }
    // if (type === 'facility') {
    //   dispatch(setCustomerFacilities(response.data))
    // }
    // console.log('asset list', response.data)
  }
  throw new Error(response.msg)
}
// spectro/assets/types/customer/aa@spectro.net?product=cold
const GetCustomerAssetTypes = async (userEmail, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }

  const response = await GET(
    `/spectro/assets/types/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    console.log('asset list', response.data)
    return response.data
  }
  throw new Error(response.msg)
}
// spectro/devices/customer/aa@spectro.net?product=cold&status=FREE
// http://localhost:9999/spectro/devices/customer/aa@spectro.net?product=cold&gateway=false
const getAssetDevices = async (userEmail, productName, id) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
    gateway: false,
    customerId: id,
  }
  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}
// http://localhost:9999/spectro/devices/customer/aa@spectro.net?product=cold&gateway=true

export const getAssetGateway = async (userEmail, productName, custID) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
    gateway: true,
    customerId: custID,
  }
  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}
// /spectro/assets/test 2222/customer/aa@spectro.net?product=cold
const GetAssetInfo = async (assetName, userEmail, productName) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))
  const response = await GET(
    `/spectro/assets/${assetName}/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

const GetCustomerDevices = async (
  userEmail,
  productName,
  currentPage,
  size,
  customerId,
) => {
  const queryParams = {
    product: productName,
    page: currentPage,
    size,
    customerId,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const GetCustomerDevicesWithSearch = async (
  userEmail,
  productName,
  currentPage,
  size,
  customerId,
  search,
) => {
  const queryParams = {
    product: productName,
    page: currentPage,
    size,
    customerId,
    name: search,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const ProvisionDevice = async (productName, userEmail, device) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const body = {
    'device id': device.id,
    email: userEmail,
  }
  console.log('provision', body)

  const response = await POST(
    `/spectro/provision-device/${device.name}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))

  return response
}
// http://localhost:9999/spectro/assets/customer/aa@spectro.net?product=cold

const saveAsset = async (
  userEmail,
  productName,
  bodyData,
  selectedStorage,
  storageCode,
  customerID,
) => {
  dispatch(SetLoader(true))
  console.log('bodyData', bodyData)
  const queryParams = {
    product: productName,
    customerId: customerID,
  }
  const weekDays = {
    sunday: bodyData.Sunday,
    monday: bodyData.Monday,
    tuesday: bodyData.Tuesday,
    wednesday: bodyData.Wednesday,
    thursday: bodyData.Thursday,
    friday: bodyData.Friday,
    saturday: bodyData.Saturday,
  }
  const weekDaysJson = JSON.stringify(weekDays)
  console.log('weekDaysJson', weekDaysJson)
  let body = {}

  body = {
    'asset thresholds': {
      'Unauthorized movement': bodyData.unauthorizedMovementThreshold,
      'compressor temperature': bodyData.compressorTemperatureThreshold,
      'compressor vibration': bodyData.compressorVibrationThreshold,
      'critical high temperature': bodyData.criticalHighTemperatureThreshold,
      'critical humidity': bodyData.criticalHumidityThreshold,
      'critical low temperature': bodyData.criticalLowTemperatureThreshold,
      'door left open': bodyData.doorOpenCountTimeSampling,
      'door open neglect': bodyData.doorOpenNeglectThreshold,
      'hw compressor ac current': bodyData.compressorTimeSampling,
      'hw compressor temperature': bodyData.compressorTimeSampling,
      'hw compressor vibrations': bodyData.compressorTimeSampling,
      'hw door open count': bodyData.doorOpenCountTimeSampling,
      'hw fridge interior humidity': bodyData.tempHumLightTimeSampling,
      'hw fridge interior light level': bodyData.tempHumLightTimeSampling,
      'hw fridge interior temperature': bodyData.tempHumLightTimeSampling,
      'hw room temperature': bodyData.roomTemperatureTimeSampling,
      'low light': bodyData.lowLightThreshold,
      'out of location': bodyData.outOfLocationThreshold,
      power: bodyData.powerThreshold,
      'warning high temperature': bodyData.warningHighTemperatureThreshold,
      'warning humidity': bodyData.warningHumidityThreshold,
      'warning low temperature': bodyData.warningLowTemperatureThreshold,
    },
    'general attributes': {
      name: bodyData.name,
      type: bodyData.assetType,
      description: bodyData.description,
      location: bodyData.GPS,
      photo: bodyData.Photo,
      floor: bodyData.Floor,
      'room no': bodyData['Room no'],
      'storage category': storageCode,
      'storage type': selectedStorage,
      'start operation time': bodyData.startOperationTime,
      'end operation time': bodyData.endOperationTime,
      'week schedule': weekDaysJson.replaceAll('"', '\\"'),
      'asset duty status': true,
    },
    'indoor fridge attributes': {
      model: bodyData.model,
      serial: bodyData.assetSerial,
    },
    'moving fridge attributes': {
      model: bodyData.model,
      'reseller name': bodyData.resellerName,
      serial: bodyData.assetSerial,
    },
    'vehicle attributes': {
      'start operation time': bodyData.startOperationTime,
      'end operation time': bodyData.endOperationTime,
      'week schedule': weekDaysJson.replaceAll('"', '\\"'),
      'fleet name': bodyData.fleetName,
      zone: bodyData.zoneId,
      'storing category': bodyData.storingCategory,
      'sequence number': bodyData.sequenceNumber,
      'vehicle plate number': bodyData.vehiclePlateNumber,
      'vehicle plate right letter': bodyData.vehiclePlateRightLetter,
      'vehicle plate middle letter': bodyData.vehiclePlateMiddleLetter,
      'vehicle plate left letter': bodyData.vehiclePlateLeftLetter,
      'plate type': bodyData.plateType,
      'imei number': bodyData.imeiNumber,
      'driver name': bodyData.driverName,
      'car model': bodyData.carModel,
    },
    'related assets': [bodyData.region, bodyData.facility, bodyData.country],
    'reports attributes': {
      'humidity incompliance report': bodyData.humidityIncomplianceReport,
      'incompliant facilities report': bodyData.criticalLowTempAlarm,
      'light incompliance report': bodyData.lightIncomplianceReport,
      'movement relocation report': bodyData.movementRelocationReport,
      'temp incompliance report': bodyData.tempIncomplianceReport,
    },
  }

  const response = await POST(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  return response
}

// spectro/devices/asset/{assetId}/{assetType}/assign?
// product=cold&customerId=9624bfd9-8e3c-4d88-9fe6-f346f091f6b7

const AssignAssetToDevice = async (
  assetId,
  assetType,
  productName,
  customer,
  bodyData,
) => {
  dispatch(SetLoader(true))
  const queryParams = { product: productName, customerId: customer }
  console.log('process.env', process.env)
  const body = bodyData

  const response = await POST(
    `/spectro/devices/asset/${assetId}/${vehicleEnum[assetType]}/assign`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  return response
}

const ChangeAssetStatus = async (assetId, status) => {
  dispatch(SetLoader(true))
  const queryParams = null
  const bodyData = null

  const response = await PUT(
    `/spectro/assets/${assetId}/${status}/change-status`,
    queryParams,
    bodyData,
  )
  dispatch(SetLoader(false))
  return response
}

const saveDevice = async (
  userEmail,
  productName,
  customer,
  deviceModel,
  imei,
  imsi,
  siteName,
  label,
  siteId,
  simNo,
  warranty,
  deliveryDate,
) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }

  const body = {
    customer,
    deviceModel,
    imei,
    imsi,
    siteName,
    label,
    siteId,
    simNo,
    warranty,
    deliveryDate,
  }

  const response = await POST(
    `/spectro/devices/${userEmail}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  return response
}

const saveColdDevice = async (userEmail, productName, bodyData) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }

  const response = await POST(
    `/spectro/devices/${userEmail}`,
    queryParams,
    bodyData,
  )
  dispatch(SetLoader(false))
  return response
}

const UnassignDevice = async (deviceType, deviceId, assetId) => {
  const response = await DELETE(
    `/spectro/assets/${deviceType}/${deviceId}/${assetId}`,
    null,
  )
  return response
}

const GetSitesUnderCustomer = async (customerId, type, productName) => {
  const queryParams = {
    customerId,
    type,
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/assets/hierarchy`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const GetSitesWithMoreThanDevice = async (customerId) => {
  const queryParams = {
    customerId,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/assets/mastersites`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const SetMasterDevice = async (bodyData) => {
  const queryParams = null
  const body = bodyData
  dispatch(SetLoader(true))

  const response = await POST(`/spectro/assets/setmaster`, queryParams, body)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const GetSiteDevices = async (siteId, type) => {
  const queryParams = {
    levelId: siteId,
    type,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/assets/hierarchy/devices`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const CreateDeviceCreateTemplateXlsx = async (
  productName,
  deviceType,
  translate,
) => {
  console.log(productName)

  try {
    await GetCreationTemplate('tank', deviceType).then((data) => {
      data.creationMap.sort((config1, config2) => {
        if (config1.sort < config2.sort) {
          return -1
        }
        if (config1.sort > config2.sort) {
          return 1
        }
        // a must be equal to b
        return 0
      })

      const xlsxHeaders = []
      data.creationMap.forEach((columnData) => {
        columnData.data.forEach((rowData) => {
          xlsxHeaders.push(translate(rowData['label ID']))
        })
      })
      CreateXlsx(
        deviceType === 'spectro-tank-assets'
          ? 'Level-Creation-Template'
          : 'Tank_Device_Template',
        xlsxHeaders,
        [],
      )
    })
  } catch (e) {
    console.log(e)
  }
}

const AddorUpdateAssetToFacility = async (queryParams) => {
  const res = await POST('/spectro/assets/facility', queryParams)
  return res
}
